import moment from "moment";

export const getStaffAvailabilityAction = () => 'afterlogin/appointment/nextresourceitemtime';

const AVAILABILITY_DATE_FORMATS = [
  "dddd, DD MMMM YYYY",
  "YYYY-MM-DD",
  "YYYY-MM-DD HH:mm:ss",
];

const parseAvailabilityDateTime = (value) => {
  if (!value) return null;
  const text = String(value);
  const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/.test(text);
  const parsed = hasOffset
    ? moment.parseZone(text)
    : moment(text, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm:ss.SSS", ...AVAILABILITY_DATE_FORMATS], true);
  return parsed.isValid() ? parsed : null;
};

/**
 * Keep availability requests in the salon's wall-clock coordinate system.
 * FullCalendar may provide an offset, but converting through the browser's
 * timezone changes the selected slot before it reaches the API.
 */
export const normalizeStaffAvailabilityValues = (values = {}) => {
  const normalized = { ...values };
  const explicitStart = parseAvailabilityDateTime(normalized.start_datetime);
  let start = explicitStart;

  if (!start) {
    const date = parseAvailabilityDateTime(normalized.dateof);
    const selectedTime = moment(normalized.start_time, ["HH:mm", "HH:mm:ss"], true);
    if (date) {
      start = date.clone();
      if (selectedTime.isValid()) {
        start.hour(selectedTime.hour()).minute(selectedTime.minute()).second(selectedTime.second());
      } else {
        start.startOf("day");
      }
    }
  }

  if (start) {
    normalized.start_datetime = start.format("YYYY-MM-DD HH:mm:ss");
    normalized.dateof = normalized.start_datetime;
  }

  const parentEnd = parseAvailabilityDateTime(normalized.parentAppointmentEndTime);
  if (parentEnd) {
    normalized.parentAppointmentEndTime = parentEnd.format("YYYY-MM-DD HH:mm:ss");
  }
  return normalized;
};
